export default "__VITE_ASSET__BP5075m5__"